module.exports = __webpack_public_path__ + "img/Canada.967f5dc5.png";